import { Button, ButtonGroup, Heading, Modal, Paragraph, TextButton } from '@zillow/constellation-10';

interface CancelModalInterface {
  isOpen: boolean;
  toggleIsOpen: (...args: any) => any;
  goToDashboard: (...args: any) => any;
}

const CancelModal = (props: CancelModalInterface) => (
  <Modal
    trigger={null}
    size="sm"
    open={props.isOpen}
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        props.toggleIsOpen();
      }
    }}
    header={<Heading level={2}>Discard your changes?</Heading>}
    body={<Paragraph>We’ll continue using your current payment method for all future payments.</Paragraph>}
    footer={
      <ButtonGroup aria-label="Discard payment method changes">
        <TextButton onClick={props.toggleIsOpen}>Back</TextButton>
        <Button emphasis="filled" onClick={props.goToDashboard}>
          Discard changes
        </Button>
      </ButtonGroup>
    }
  />
);

export default CancelModal;
